import request from "@/plugins/request";
import { User } from "@/models/User";
import { WellKnownRoles, hasAnyRole } from "@/models/User";

const state = {
	status: "",
	user: null,
	redirectUri: null,
};

const getters = {
	isLoggedIn(state: any) {
		return !!state.user;
	},
	authStatus: (state: { status: any }) => state.status,
	userInfo: (state: { user: any }) => {
		return state.user;
	},
	redirectUri: (state: any) => {
		return state.redirectUri;
	},
};

const mutations = {
	auth_request(state: { status: string }) {
		state.status = "loading";
	},
	auth_success(state: { status: string; user: any }, userInfo: any) {
		state.status = "success";
		state.user = initUser(userInfo);
	},
	auth_error(state: { status: string }) {
		state.status = "error";
	},
	logout(state: { status: string; user: null }) {
		state.status = "";
		state.user = null;
	},
	save_redirect(state: { status: string; user: any; redirectUri: any }, path: any) {
		state.redirectUri = path;
	},
};

const actions = {
	login({ commit }: any, user: any) {
		return new Promise((resolve, reject) => {
			commit("auth_request");
			request({ url: "/api/auth/login", data: user, method: "POST" })
				.then((resp: any) => {
					console.log("success", resp);
					const userInfo: User = resp.data.user;
					commit("auth_success", userInfo);
					resolve(resp);
				})
				.catch((err: any) => {
					commit("auth_error");
					reject(err);
				});
		});
	},
	register({ commit }: any, user: any) {
		return new Promise((resolve, reject) => {
			commit("auth_request");
			request({ url: "/api/users", data: user, method: "POST" })
				.then((resp: any) => {
					console.log(resp);
					const userInfo = resp.data.user;
					commit("auth_success", userInfo);
					resolve(resp);
				})
				.catch((err: any) => {
					commit("auth_error");
					reject(err);
				});
		});
	},
	refreshUserInfo({ commit, state }: any) {
		return new Promise((resolve, reject) => {
			if (state.user) {
				request({ url: "/api/auth/me", method: "GET" })
					.then((resp) => {
						console.log("me", resp);
						const userInfo = resp.data;
						commit("auth_success", userInfo);
						resolve(userInfo);
					})
					.catch((err: any) => {
						reject(err);
					});
			} else {
				reject(new Error("No user logged in"));
			}
		});
	},
	logout({ commit }: any): Promise<void> {
		return new Promise((resolve) => {
			commit("logout");
			window.sessionStorage.clear();
			resolve();
		});
	},
	setRedirect({ commit }: any, redirect: any) {
		return new Promise((resolve) => {
			if (redirect) {
				commit("save_redirect", redirect);
			}

			resolve(redirect);
		});
	},
	clearRedirect({ commit }: any) {
		commit("save_redirect", null);
	},
};

function initUser(user: User): User {
	const initialFirst = user.firstName && user.firstName.length > 0 ? user.firstName[0] : "";
	const initialLast = user.lastName && user.lastName.length > 0 ? user.lastName[0] : "";
	const initials = (initialFirst + initialLast).toUpperCase();
	const isAdmin = hasAnyRole(user, [WellKnownRoles.ADMIN, WellKnownRoles.SUPER_ADMIN]);
	return { ...user, initials, isAdmin };
}

export default {
	state,
	mutations,
	actions,
	getters,
};
